export default {
  // Common words
  enter: "Invoeren",
  next: "Volgende",
  previous: "Vorige",
  finish: "Voltooien",
  returnToWebsite: "Terug naar website",
  complete: "Voltooien",
  submit: "Verzenden",
  cancel: "Annuleren",
  yes: "Ja",
  no: "Nee",
  skip: "Overslaan",
  close: "Sluiten",
  discard: "Verwijderen",
  save: "Opslaan",
  "thank-you": "Dank u wel",
  select: "Selecteren",
  hi: "Hoi",
  hello: "Hallo",
  link: "Link",
  back: "Terug",
  view: "Bekijken",
  continue: "Doorgaan",
  of: "van",

  // Client Survey Main
  "client-survey-main-thanks-note":
    "Bedankt voor uw tijd, uw feedback bepaalt mede ons aanbod <br /> voor de toekomst.",
  "client-survey-how-likely-recommend":
    "Hoe waarschijnlijk is het dat u ons zou aanbevelen aan anderen?",
  "client-survey-how-likely-note":
    "Op een schaal van 0 - 10, waarbij 0 helemaal niet waarschijnlijk is en 10 zeer waarschijnlijk.",
  "client-survey-how-likely-recommend-question":
    "Wat is het ene ding dat wij zouden kunnen doen om u eerder geneigd te maken ons aan te bevelen?",
  "step-of": "Stap {step} van {total}",
  step: "Stap {step}",
  "client-survey-how-satisfied-with-service":
    "Hoe tevreden bent u met de service",
  "client-survey-how-satisfied-with-service-question":
    "Wat is het ene ding dat wij zouden kunnen doen om te verbeteren?",
  "client-survey-how-satisfied-with-food":
    "Hoe tevreden bent u met het eten dat u van ons ontvangt?",
  "client-survey-how-satisfied-with-food-question":
    "Wat is het ene ding dat wij zouden kunnen doen om te verbeteren?",
  "client-survey-what-is-the-best-thing-about-working-with-us":
    "Wat is het beste aan het werken met ons? Selecteer alles wat van toepassing is.",
  "management-team": "Managementteam",
  "the-front-line-operations-team": "Het operationele team op de werkvloer",
  "food-offering": "Voedselaanbod",
  innovation: "Innovatie",
  communication: "Communicatie",
  "flexibility-and-responsiveness": "Flexibiliteit en Reactievermogen",
  billing: "Facturering",
  "health-and-hygiene-standards": "Gezondheids- en Hygiënenormen",
  "if-other-please-specify": "Indien anders, geef aan wat...",
  "based-on-the-service-we-provide-where-can-we-improve-the-most-please-select-all-that-matters":
    "Op basis van de service die wij leveren, waar kunnen wij het meest verbeteren? Selecteer alles wat van toepassing is.",
  "please-can-we-have-some-more-detail": "Kunt u dit iets toelichten?",
  "to-help-us-understand-your-csr-priorities-please-order-in-rank-of-importance-the-following":
    "Om ons te helpen uw MVO-prioriteiten te begrijpen, kunt u het volgende rangschikken naar belangrijkheid:",
  "sustainable-ingredients": "Duurzame Ingrediënten",
  "food-waste": "Voedselverspilling",
  "local-sourcing": "Lokale Inkoop",
  "people-and-communities": "Mensen &amp; Gemeenschappen",
  "energy-reduction": "Energiereductie",
  "working-with-local-communities": "Samenwerken met lokale gemeenschappen",
  "environmental-choices": "Milieukeuzes",
  "meat-free": "Vleesvrij",
  "less-plastic": "Minder Plastic",
  "would-you-like-to-be-contacted-about-your-feedback":
    "Wilt u benaderd worden naar aanleiding van uw feedback? Laat dan hieronder uw contactgegevens achter",
  "full-name": "Volledige Naam",
  "email-address": "E-mailadres",
  "phone-number": "Telefoonnummer",
  feedback: "Feedback",
  "view-our-privacy-policy": "Bekijk ons Privacybeleid",
  "thank-you-for-taking-time-to-complete-the-survey":
    "Hartelijk dank voor het invullen van de enquête!",

  // 404 Not Found
  "404-not-found": "404 Niet Gevonden",

  // Privacy Policy
  "privacy-policy": "Privacybeleid",

  // Employee Web Rating Feedback Step 1
  "employee-web-rating-feedback-step-1-positive":
    "Fijn om te horen dat u zich positief voelt, we horen graag waarom!",
  "employee-web-rating-feedback-step-1-negative":
    "Vervelend om te horen dat u zich niet optimaal voelt, kunt u ons vertellen waarom?",

  // Employee Web Rating Feedback Step 2
  "employee-web-rating-feedback-step-2-heading":
    "Is er verder nog iets dat u vandaag met ons wilt delen?",
  "employee-web-rating-feedback-step-2-information":
    "Heeft u opmerkingen of feedback over uw ervaring met ons vandaag?",
  "employee-web-rating-feedback-step-2-placeholder":
    "Deel uw ervaring met ons vandaag...",

  // Employee Web Rating Feedback Step 3
  "employee-web-rating-feedback-step-3-heading":
    "Wilt u iemand een compliment geven?",
  "no-employees-found": "Geen medewerkers gevonden",

  // Employee Web Rating Home
  "choose-location": "Kies Locatie",
  "search-location": "Zoek Locatie",
  "feedback-anonymous": "Wilt u uw feedback anoniem houden?",
  "feedback-feeling-today": "Hoe voelt u zich vandaag?",

  // Employee Web Rating Thankyou Page
  "thank-you-for-your-feedback": "Hartelijk dank voor uw feedback!",
  "back-to-home": "Terug naar Home",
  page: "Pagina",

  // Feedback Once Alert
  "feedback-once-alert": "Er is al eenmalig feedback gegeven vanaf deze URL.",

  // Front Customer Audit
  "please-answer-above-question": "Beantwoord de bovenstaande vraag.",
  "add-comments": "Opmerkingen Toevoegen",
  "enter-answer": "Antwoord Invoeren",
  "add-upload-files": "Bestanden Uploaden",

  // Alphega Questions
  "did-you-buy-medicine-in-the-pharmacy-today":
    "Heeft u vandaag medicijnen opgehaald in de apotheek?",
  "were-you-asked-any-of-the-following":
    "Is u een van de volgende vragen gesteld:",
  "who-is-the-medicine-for": "Voor wie is het medicijn bedoeld?",
  "what-are-your-symptoms": "Wat zijn uw symptomen?",
  "how-long-you-had-the-symptoms": "Hoe lang heeft u al last van de symptomen?",
  "what-action-you-have-already-taken": "Welke actie heeft u al ondernomen?",
  "are-you-taking-any-other-medication": "Gebruikt u nog andere medicatie?",

  // Alphega - Other Companies Questions
  "did-you-wait-more-than-10-minutes-to-be-served":
    "Heeft u langer dan 10 minuten moeten wachten voordat u werd geholpen?",
  "were-the-products-you-wanted-in-stock":
    "Waren de producten waarvoor u kwam op voorraad?",
  "were-the-staff-friendly-and-helpful":
    "Waren de medewerkers vriendelijk en behulpzaam?",
  "did-you-receive-any-advice-about-your-medicines":
    "Heeft u advies gekregen over uw medicijnen of gezondheid?",

  // Front Mobile Home
  "how-was-your-experience-with-us-today":
    "Hoe was uw ervaring met ons vandaag?",

  // Front Mobile Thankyou Page
  "thank-you-for-your-time-and-your-answers":
    "Hartelijk dank voor uw tijd en uw antwoorden.",
  "would-also-like-to-rate-us-on-google":
    "Zou u ons ook willen beoordelen op Google?",
  "rate-us-now": "Beoordeel ons nu",

  // Negative Chat Reply
  "select-skill": "Selecteer Vaardigheid",
  "none-selected": "Niets Geselecteerd",
  "can-we-get-in-touch-with-you-about-your-experience-today":
    "Mogen wij contact met u opnemen over uw ervaring van vandaag?",
  "write-here": "Schrijf hier...",
  "please-can-we-get-your-name": "Mogen wij uw naam weten?",
  "please-enter-your-email": "Voer uw e-mailadres in:",
  "enter-your-phone-number": "Voer uw telefoonnummer in:",
  "please-tell-us-a-bit-more-about-your-experience":
    "Vertel ons iets meer over uw ervaring:",
  "you-have-already-submitted-rating": "U heeft al een beoordeling ingediend",
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Vervelend om te horen dat u vandaag geen goede ervaring met ons heeft gehad, kunt u aangeven wat er mis is gegaan?",

  // Positive Chat Reply
  "select-employee": "Selecteer Medewerker",
  "we-d-love-to-know-who-looked-after-you-today":
    "We horen graag wie er vandaag voor u heeft gezorgd?",
  "what-stood-out-to-you-today": "Wat viel u vandaag op?",
  "did-we-provide-exceptional-service-today":
    "Hebben wij vandaag uitzonderlijke service geleverd?",
  "do-you-have-any-comments-or-feedback-about-your-experience-with-us-today":
    "Heeft u opmerkingen of feedback over uw ervaring met ons vandaag?",

  // Client Connect Director
  "message-from-leadership": "Bericht van de Directie",
  "message-from-leadership-text":
    "Ik ben voortdurend op zoek naar manieren om ons aanbod voor onze klanten te verbeteren. Zijn er volgens u zaken die wij beter zouden kunnen doen?",
  "client-connect-director-another-note":
    "Daarnaast, als er een specifiek onderwerp is dat u door ons team behandeld wilt zien, aarzel dan niet om dit te delen. Ik ben er niet alleen om te luisteren, maar ook om actie te ondernemen naar aanleiding van uw zorgen of ideeën.",
  "your-message-here": "Uw bericht hier",
  "visit-information": "Bezoekinformatie",
  "visit-time-out": "Vertrektijd Bezoek",
  "contact-information": "Contactgegevens",
  "client-connect-director-contact-information-text":
    "Om u beter van dienst te kunnen zijn, vragen wij u vriendelijk om uw gegevens, waaronder uw naam, e-mailadres en telefoonnummer. Met deze informatie kunnen wij snel reageren en contact met u opnemen.",
  name: "Naam",
  "enter-your-name": "Voer uw naam in",
  email: "E-mail",
  "enter-your-email": "Voer uw e-mailadres in",
  "contact-number": "Telefoonnummer",
  "please-enter-your-name": "Voer uw naam in",
  "please-enter-your-email-or-phone-number":
    "Voer uw e-mailadres of telefoonnummer in",
  "invalid-email-address": "Ongeldig e-mailadres",
  "invalid-phone-number-format":
    "Ongeldig telefoonnummer voor het geselecteerde land.",
  "no-match-found": "Geen resultaten gevonden",
  "phone-number-must-be-digits-for-country":
    "Het telefoonnummer moet {count} cijfers bevatten voor het geselecteerde land ({current}/{count}).",
  "phone-number-must-be-digits-range-for-country":
    "Het telefoonnummer moet {min}–{max} cijfers bevatten voor het geselecteerde land ({current}/{max}).",
  "please-select-time": "Selecteer een tijdstip",
  "you-must-provide-at-least-one-answer-before-submitting-the-survey":
    "U dient ten minste één antwoord te geven voordat u de enquête kunt indienen.",

  // Mobile Survey Questions CheckBoxType
  comment: "Opmerking",
  "comment-is-required": "Opmerking is verplicht!",
  "minimum-selection-is": "Minimale selectie is {min_options}",
  "maximum-selection-is": "Maximale selectie is {max_options}",
  "this-question-is-required": "Deze vraag is verplicht!",
  "please-fill-all-required-grid-rows": "Vul alle verplichte rijen in!",
  "please-fill-mandatory-fields-to-continue":
    "Vul de verplichte velden in om door te gaan",

  // Mobile Survey Questions CommentsAndImage
  "please-select-valid-image-files": "Selecteer geldige afbeeldingsbestanden.",

  // Mobile Survey Questions EmployeeType
  loading: "Laden",
  "getting-employee": "Medewerker ophalen...",

  // Mobile Survey Questions FileUploadType
  "please-select-valid-image-or-video-files":
    "Selecteer geldige afbeeldings- of videobestanden.",
  "please-select-a-valid-file":
    "Selecteer een geldig bestand (afbeelding, video, PDF of Word).",

  // Mobile Survey Questions NumberType
  "please-enter-a-number-without-any-decimal-points":
    "Voer een getal in zonder decimalen.",
  "please-enter-a-number-less-than-or-equal-to":
    "Voer een getal in dat kleiner is dan of gelijk is aan {max_number_value}.",

  // Mobile Survey Questions SignatureType
  "please-complete-your-signature": "Voltooi uw handtekening.",

  // Mobile Survey Questions TextType
  "please-enter-valid-email-address": "Voer een geldig e-mailadres in.",
  "phone-number-should-be-10-digit": "Telefoonnummer moet 10 cijfers bevatten.",
  "please-enter-at-least-characters":
    "Voer ten minste {minimum_character} tekens in.",
  "select-date": "Selecteer Datum",
  "select-time": "Selecteer Tijd",
  "client-connect-date-picker-aria": "Datum: {value}. Datumkiezer openen",
  "client-connect-time-picker-aria": "Tijd: {value}. Tijdkiezer openen",
  "select-country": "Selecteer Land",

  // Report Page
  "click-the-link-to-see-how": "Klik op de link om te zien hoe.",
  "adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Door uw teams toe te voegen aan het ServeFirst-rapportageplatform kunnen zij ook inloggen om hun prestaties te bekijken. Daarnaast heeft u de mogelijkheid om uw team te beheren en toegang te krijgen tot aanvullende rapporten om te begrijpen hoe u het als geheel doet -",
  "did-you-know": "Wist u dat..",
  count: "aantal",
  average: "gemiddelde",
  focus: "focus",
  performance: "Prestaties",
  "you-can-create-bespoke-action-plans":
    "U kunt op maat gemaakte actieplannen aanmaken die hier direct in doorwerken, mits deze zijn aangemaakt binnen uw ServeFirst-account. Hier kunt u direct acties, tijdlijnen en eigenaren toewijzen terwijl u de prestaties volgt. -",
  "no-of-times-raised": "Aantal Keer Gemeld",
  action: "Actie",
  "attribute-name": "Naam Kenmerk",
  "action-plan": "Actieplan",
  "that-by-adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Door uw teams toe te voegen aan het ServeFirst-rapportageplatform kunnen zij ook inloggen om hun prestaties te bekijken. Daarnaast heeft u de mogelijkheid om uw team te beheren en toegang te krijgen tot aanvullende rapporten om te begrijpen hoe u het als geheel doet -",
  result: "Resultaat",
  category: "Categorie",
  "your-location-vs-all-location": "Uw Locatie vs. Alle Locaties",
  "net-promoter-score": "Net Promoter Score",
  "responses-breakdown": "Overzicht van Reacties",
  "trended-net-promoter-score": "Net Promoter Score Trend",
  "trended-results": "Resultaten Trend",
  "net-promoter-score-info":
    "De Net Promoter Score is gebaseerd op het % promoters (score van 5/5) min het % criticasters (score van 1, 2 of 3). Meer informatie over de Net Promoter Score vindt u door hierop te klikken",
  "customer-feedback": "Klantfeedback",
  logan: "Logan",
  "top-performer": "Best Presterende",
  "rank-in-the-country": "Positie in het Land",
  "ytd-score": "Score Jaar tot Datum",
  "score-during-period": "Score Gedurende de Periode",
  "0-from-last-month": "0 ten opzichte van vorige maand",
  "total-responses-for-july-2021": "Totaal aantal reacties voor juli 2021",
  promoter: "Promoter",
  "from-04-sep-2021-to-06-sep-2021": "Van 04 sep. 2021 tot 06 sep. 2021",
  "the-focus-currently-is-on": "De huidige focus ligt op",
  "1-number-of-customers-have-stated-this-as-an-opportunity":
    "1 klant heeft dit aangegeven als verbeterpunt.",
  "focus-for-the-month": "Focus voor de Maand",
  "download-pdf": "PDF downloaden",

  // Report Page New Report
  "total-responses": "Totaal Aantal Reacties",
  duration: "Duur",
  "customers-have-stated-this-as-an-opportunity":
    "klanten hebben dit aangegeven als verbeterpunt",
  "error-fetching-params": "Fout bij het ophalen van parameters!",
  "previous-days-was": "Vorige {days} dagen was {score}",

  // Report Page Common LgCard
  "raised-on": "# Gemeld op",
  results: "Resultaten",

  // Report Page Components AiSuggestions
  "analyzing-data-please-wait":
    "Gegevens worden geanalyseerd, een moment geduld...",

  // Report Page Components CustomerFeedBack
  "view-report": "Rapport Bekijken",
  "received-on": "Ontvangen op",

  // Report Page Components ResponseBreakdown
  detractors: "Criticasters",
  nps: "NPS",

  // Report Page Components TrendResults
  "trend-results": "Trendresultaten",

  // Survey helpers Utils
  "failed-to-fetch-the-pdf-file": "Het ophalen van het PDF-bestand is mislukt",
  "error-generating-pdf-thumbnail":
    "Fout bij het genereren van de PDF-miniatuur",
  "error-in-thumbnail-generation-function":
    "Fout in de functie voor het genereren van miniaturen",
  "failed-to-generate-pdf-thumbnail":
    "Het genereren van de PDF-miniatuur is mislukt",

  // Survey Pages Audition
  "select-audit": "Selecteer Audit",

  // Survey Pages ClientConnect
  "select-atleast-min-options": "Selecteer ten minste {minOptions} opties",
  "select-max-options": "Maximaal {maxOptions} opties toegestaan!",
  "error-saving-your-response": "Fout bij het opslaan van uw antwoord!",
  "failed-to-load-the-file": "Het laden van het bestand is mislukt!",
  "open-link": "Link Openen",
  download: "Downloaden",
  details: "Details",
  title: "Titel",
  description: "Beschrijving",
  "general-info": "Algemene Informatie",
  type: "Type",
  size: "Grootte",
  "uploaded-by": "Geüpload door",

  // Survey Pages ClientConnect Intro
  "thank-you-for-your-time": "Hartelijk dank voor uw tijd!",

  // Survey Pages ClientConnect Content
  "review-content": "Inhoud beoordelen",

  // Survey Pages ClientConnect Survey
  "please-give-us-your-feedback": "Geef ons uw feedback",
  "enter-your-response": "Voer uw antwoord in",

  // Client Connect v2 (accordion UI)
  "client-connect-preview-hey": "Hallo, {name}",
  "client-connect-preview-sent-from": "Verzonden door {sender} - {date}",
  "client-connect-preview-step-of": "Stap {current} van {total}",
  "client-connect-preview-getting-started": "Aan de Slag",
  "client-connect-preview-getting-started-desc":
    "Bekijk het overzicht van de voor u voorbereide materialen.",
  "client-connect-preview-share-feedback": "Deel Uw Feedback",
  "client-connect-preview-share-feedback-desc":
    "Uw inbreng helpt ons een betere ervaring voor u te creëren.",
  "client-connect-preview-talk-leadership": "In gesprek met de directie",
  "client-connect-preview-talk-leadership-desc":
    "Lees het bericht van de directie en sla uw antwoord op.",
  "client-connect-preview-reviewed-these": "Ik heb dit doorgenomen",
  "client-connect-preview-send-feedback": "Feedback verzenden",
  "client-connect-preview-finish-submit": "Voltooien & indienen",
  "client-connect-preview-save-finish": "Voltooien & Indienen",
  "client-connect-preview-your-reply": "Uw antwoord",
  "client-connect-preview-saved": "Opgeslagen",
  "client-connect-preview-edit": "Bewerken",
  "client-connect-preview-pop-out": "Loskoppelen",
  "client-connect-preview-open": "Openen",
  "client-connect-preview-view": "Bekijken",
  "client-connect-preview-welcome": "Welkom",
  "client-connect-preview-feedback": "Feedback",
  "client-connect-preview-save-message": "Bericht Verzenden",
  "client-connect-preview-message-footer":
    "Uw bericht gaat rechtstreeks naar het directieteam.",
  "client-connect-preview-leadership-placeholder": "Voer uw bericht in...",
  "client-connect-preview-thank-you": "Dank u wel",
  "client-connect-preview-thank-you-body":
    "U heeft Client Connect voltooid. Uw enquête-antwoorden en bericht zijn verzonden naar het team — zij nemen binnenkort contact met u op.",
  "client-connect-thank-you-message":
    "Hartelijk dank voor uw tijd. Uw feedback maakt echt het verschil.",
  "client-connect-preview-review-answers": "Mijn antwoorden bekijken",
  "client-connect-preview-back-dashboard": "Terug naar dashboard",
  "client-connect-preview-already-submitted":
    "U heeft uw feedback voor deze uitnodiging al ingediend. U kunt de overzichtsmaterialen hieronder nog steeds bekijken.",
  "enter-email-address": "Voer e-mailadres in",
  "enter-phone-no": "Voer telefoonnummer in",
  "product-type": "Producttype",
  "enter-number": "Voer nummer in",
  aspect: "Aspect",

  // Survey Pages ClientConnect Director
  "i-am-constantly-seeking-ways-to-better-our-offerings-for-our-clientele":
    "Ik ben voortdurend op zoek naar manieren om ons aanbod voor onze klanten te verbeteren. Zijn er volgens u zaken die wij beter zouden kunnen doen?",
  "on-another-note-if-there-s-a-specific-topic-you-d-like-our-team-to-address-don-t-hesitate-to-share":
    "Daarnaast, als er een specifiek onderwerp is dat u door ons team behandeld wilt zien, aarzel dan niet om dit te delen. Ik ben er niet alleen om te luisteren, maar ook om actie te ondernemen naar aanleiding van uw zorgen of ideeën.",
  "to-provide-enhanced-assistance-we-kindly-ask-for-your-details-including-your-name-email-address-and-contact-number":
    "Om u beter van dienst te kunnen zijn, vragen wij u vriendelijk om uw gegevens, waaronder uw naam, e-mailadres en telefoonnummer. Met deze informatie kunnen wij snel reageren en contact met u opnemen.",

  // Survey Pages Location
  "select-the-location-you-visited": "Selecteer de locatie die u heeft bezocht",
  locations: "Locaties",
  "is-this-your-current-location": "Is dit uw huidige locatie?",
  "nearest-location": "Dichtstbijzijnde Locatie",
  "loading-data": "Gegevens laden...",
  "please-wait": "Een Moment Geduld!",

  // Survey Pages Location Area
  "location-area": "Locatiegebied",
  "select-location-area": "Selecteer Locatiegebied",

  // Survey Pages Login
  "please-enter-your-password": "Voer uw wachtwoord in",
  "value-must-be-longer-than-3-characters":
    "Waarde moet langer zijn dan 3 tekens",
  "please-enter-your-email-address": "Voer uw e-mailadres in",
  password: "Wachtwoord",
  "internal-server-error": "Interne Serverfout!",
  "sign-in": "Inloggen",

  // Survey Pages SameDaySurvey
  "you-have-already-performed-this-survey": "U heeft deze enquête al voltooid!",
  "csat-link-invalid": "Deze enquêtelink is niet meer geldig.",

  // Survey Pages SurveyThankYou
  "your-feedback-has-been-submitted":
    "Uw feedback is verzonden. Uw ticketnummer is #",
  "a-member-of-the-team-will-be-in-touch-shortly":
    "Een teamlid neemt binnenkort contact met u op.",
  "would-you-also-like-to-rate-us-on-google":
    "Zou u ons ook willen beoordelen op Google?",
  "to-review-our-terms-and-conditions-please-click":
    "Om onze Algemene Voorwaarden te bekijken, klikt u",
  here: "Hier",
  "ticket-number-copied-to-clipboard": "Ticketnummer gekopieerd naar klembord",

  // Survey Pages Welcome
  "visit-date": "Bezoekdatum",
  "visit-time-in": "Aankomsttijd Bezoek",
  "please-select-date": "Selecteer een Datum",
  "guest-info": "Bezoekersinformatie",
  "please-select-user": "Selecteer een Gebruiker",
  "get-started": "Aan de Slag",

  // Survey Pages InventoryType
  "enter-value": "Voer waarde in",
  "getting-product-list": "Productlijst ophalen...",

  // Survey Pages NotesAndImage
  "upload-file": "Bestand Uploaden",

  // Survey Pages NumberType
  "enter-digit": "Voer cijfer in",

  // Survey Pages TextArea
  "enter-your-comment": "Voer uw opmerking in",

  // Survey Pages Upload
  "file-size-should-be-less-than-10-mb":
    "Bestandsgrootte moet kleiner zijn dan 10 MB",
  "drag-you-files-here-file-size-less-than-10-mb-or":
    "Sleep uw bestanden hierheen, bestandsgrootte kleiner dan 10 MB, of",
  "upload-or-drag-and-drop-your-files-here":
    "Upload of sleep uw bestanden hierheen",
  "browse-files": "Bestanden Bladeren",

  // Survey Pages Questions
  "next-question": "Volgende Vraag",
  "save-and-exit": "Opslaan en Afsluiten",
  "failed-to-save-and-exit":
    "Uw voortgang kon niet worden opgeslagen. Probeer het opnieuw.",
  "progress-saved-you-may-close-this-tab":
    "Uw voortgang is opgeslagen. U kunt dit browsertabblad nu sluiten.",
  "please-enter-at-least": "Voer ten minste {min} tekens in.",
  "contact-no": "Contactnummer",
  "please-select-location": "Selecteer een Locatie!",
  "please-select-survey": "Selecteer een Enquête!",
  "please-enter-your-email-address-or-phone-number":
    "Voer uw e-mailadres of telefoonnummer in.",

  // Utils CompressFiles
  "compression-error": "Compressiefout:",

  // Web Rating FrontLogin
  "enter-location-id": "Voer Locatie-ID in",
  "invalid-location-id": "Ongeldig Locatie-ID",
  "location-id-required": "Locatie-ID is verplicht",

  // Web Rating Index
  "please-tell-us-how-your-experience-was-today":
    "Vertel ons hoe uw ervaring vandaag was.",

  // Web Rating Negativefeedback
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Vervelend om te horen dat u vandaag geen goede ervaring met ons heeft gehad, kunt u aangeven wat er mis is gegaan?",
  "enter-valid-email-address": "Voer een geldig e-mailadres in.",
  "can-we-get-in-touch-with-you": "Mogen wij contact met u opnemen?",

  // Web Rating Positivefeedback
  "enter-your-telephone-number": "Voer uw telefoonnummer in",
  "write-your-feedback": "Schrijf uw feedback",

  // Web Rating Positivefeedback2
  "what-made-the-employee-name-stand-out-to-you":
    "Wat viel u op aan {employeeName}?",
  team: "Team",

  // Web Rating PositivefeedbackForm
  "please-go-to-previous-step-and-select-employee-without-employee-selection-not-able-to-submit-feedback-form":
    "Ga terug naar de vorige stap en selecteer een medewerker, zonder een geselecteerde medewerker kan het feedbackformulier niet worden ingediend",
  "share-us-your-experience-with-us-today":
    "Deel uw ervaring met ons vandaag...",
  "did-employee-name-provide-exceptional-service":
    "Heeft {employeeName} uitzonderlijke service geleverd?",
  "did-employee-name-stand-out-for-delivering-exceptional-service":
    "Viel {employeeName} op door het leveren van uitzonderlijke service?",

  // Web Rating New apiHelpers loginHelpers
  "please-enter-user-name": "Voer gebruikersnaam in",
  "please-enter-password": "Voer wachtwoord in",

  // Web Rating New RatingLocations
  search: "Zoeken",
  "select-loction-to-ratings": "Selecteer locatie voor beoordelingen",
  location: "Locatie",
  "is-this-your-location": "Is dit uw locatie?",
  "fetch-details-failed": "Ophalen van gegevens mislukt",

  // Web Rating New PositiveJourny EmployeDetail
  "click-as-many-as-you-want": "Klik zoveel als u wilt",
  "what-made-employee-name-stand-out-to-you":
    "Wat viel u op aan {employeeName}?",
  "what-made-the-team-stand-out-to-you": "Wat viel u op aan het team?",

  // Web Rating New PositiveJourny EmployeService
  "did-we-stand-out-for-delivering-exceptional-service":
    "Zijn wij opgevallen door het leveren van uitzonderlijke service?",

  // Web Rating New NegativeJourny EmployePersonalDetail
  "leave-an-email-or-phone-number-if-you-want-us-to-get-in-touch-otherwise-just-leave-it-blank-then-press-next":
    "Laat een e-mailadres of telefoonnummer achter als u wilt dat wij contact met u opnemen, laat het anders leeg en klik op volgende",
  "anything-else-you-d-like-to-share": "Wilt u verder nog iets delen?",
  "enter-valid-email": "Voer geldig e-mailadres in",
  message: "Bericht",
  "by-signing-up-the-form-you-agree-to-our-terms-and-privacy":
    "Door dit formulier in te vullen, gaat u akkoord met onze Voorwaarden en Privacybeleid.",

  // Web Rating New FrontWebLogin
  login: "Inloggen",
  username: "Gebruikersnaam",

  // Web Rating New FrontRating
  "press-the-facial-expression-that-best-represents-how-you-feel-about-your-experience":
    "Klik op de gezichtsuitdrukking die het beste weergeeft hoe u zich voelt over uw ervaring.",
  "getting-employee-list": "Medewerkerslijst ophalen",
  "getting-skill-data": "Vaardighedengegevens ophalen",
  "getting-screen-saver": "Schermbeveiliging ophalen",

  // Web Rating New CommonComponents ThankYouModal
  "thank-you-for-contacting-us": "Hartelijk dank voor uw bericht.",
  "we-ll-be-in-touch-very-soon": "Wij nemen zeer binnenkort contact met u op.",

  // Web Rating New CommonComponents GoogleQrPage
  "you-can-follow-this-button-to-rate-us-on-google":
    "U kunt via deze knop een beoordeling voor ons achterlaten op Google",
  "rate-us-on-google": "Beoordeel ons op Google",

  // Web Rating New CommonComponents ContactUsModal
  "contact-us": "Neem Contact Op",
  "or-you-may-reach-us-on": "...of u kunt ons bereiken via.",
  "do-you-want-to-learn-more-about-serve-first":
    "Wilt u meer weten over Serve First?",

  // Web Rating New CommonComponents BottomBar
  saving: "Opslaan",
  "please-enter-only-digits-for": "Voer alleen cijfers in voor",
  "please-enter": "Voer in",
  "enter-value-here": "Voer hier waarde in",

  // Survey Pages Questions Dropdown
  "please-select": "Selecteer",
  "survey-retry-message":
    "U kunt deze enquête opnieuw invullen na {value} {unit}.",
  minute: "minuut",
  minutes: "minuten",
  hour: "uur",
  hours: "uur",
  day: "dag",
  days: "dagen",
  week: "week",
  weeks: "weken",
  month: "maand",
  months: "maanden",
  clear: "Wissen",

  "powered-by": "Mogelijk gemaakt door",
  "image-is-required": "Afbeelding is verplicht",
  "please-fill-all-required-contact-information":
    "Vul alle verplichte contactgegevens in",

  "please-leave-any-extra-feedback-in-the-box-below":
    "Laat eventuele aanvullende feedback achter in het onderstaande vak.",
  "all-feedback-is-confidential": "Alle feedback is vertrouwelijk",
  "your-feedback-has-been-received-thank-you":
    "Uw feedback is ontvangen, hartelijk dank",
  "close-page": "Pagina sluiten",
  send: "Verzenden",
  sending: "Verzenden",
  "enter-your-feedback-here": "Voer hier uw feedback in",
  "for-anything-else-please": "Voor al het overige kunt u ",
  "please-correct-the-custom-field-values":
    "Corrigeer de waarden van de aangepaste velden",
  "please-complete-all-required-contact-information":
    "Vul alle verplichte contactgegevens in",
  "survey-cannot-be-submitted": "Enquête kan niet worden ingediend",
  "please-enter-your-phone": "Voer uw telefoonnummer in",
  "network-error-please-try-again":
    "Netwerkfout. Controleer uw verbinding en probeer het opnieuw.",
  "no-results-found": "Geen resultaten gevonden",
  "drop-files-here": "Zet de bestanden hier neer...",
  "drag-drop-files":
    "Sleep hier bestanden naartoe, of klik om bestanden te selecteren",
  "max-5-files-5mb": "Max. 5 bestanden, 5 MB per stuk, alleen afbeeldingen",
  remove: "Verwijderen",

  // Learning & Development

  "ld-module-title": "Leren en ontwikkeling",
  "ld-no-sign-in-required": "Inloggen is niet vereist",
  "ld-progress-warning":
    "Sluit dit venster niet — uw voortgang wordt niet opgeslagen en u zou opnieuw moeten beginnen.",
  "ld-loading-module": "Leermodule laden…",
  "ld-unable-load-module": "Leermodule kan niet worden geladen.",
  "ld-package-not-configured": "Het leermodulepakket is niet geconfigureerd.",
  "ld-start-guidance": "Start training",
  "ld-due-date": "Deadline {date}",
  "ld-whats-involved": "Wat komt eraan",
  "ld-your-progress": "UW VOORTGANG",
  "ld-step-of": "Stap {current} van {total}",
  "ld-watched-in-full": "Volledig bekeken",
  "ld-video-no-skip": "U kunt terugspoelen, maar niet vooruitspoelen",
  "ld-video-muted-counts": "Gedempt — afspelen telt nog steeds",
  "ld-maximize-document": "Document maximaliseren",
  "ld-minimize-document": "Document minimaliseren",
  "ld-read-percent": "{percent}% gelezen",
  "ld-end-of-document": "Einde van het document",
  "ld-scroll-to-continue": "Scroll om door te gaan",
  "ld-read-to-end": "Tot het einde gelezen",
  "ld-read-to-end-to-continue": "Lees tot het einde om door te gaan",
  "ld-loading-document": "Document laden…",
  "ld-pdf-preview-unavailable":
    "Deze PDF kan niet in de browser worden weergegeven.",
  "ld-pdf-page-alt": "{title} — pagina {page}",
  "ld-knowledge-check": "KENNISTOETS",
  "ld-knowledge-check-title": "{title} — kennistoets",
  "ld-quiz-instruction":
    "Beantwoord alle {count, plural, one {# vraag} other {# vragen}}. Slagingsdrempel {passMark}%.",
  "ld-quiz-instruction-pass-only": "Slagingsdrempel {passMark}%.",
  "ld-question-of": "VRAAG {current} VAN {total}",
  "ld-guidance-of": "TRAINING {current} VAN {total}",
  "ld-loading-questionnaire": "Vragenlijst laden…",
  "ld-preparing-questions": "Uw vragen worden voorbereid",
  "ld-submit-answers": "Antwoorden verzenden",
  "ld-submitting": "Verzenden…",
  "ld-ready-to-submit": "Klaar om uw antwoorden te verzenden",
  "ld-answer-selected": "Antwoord geselecteerd",
  "ld-select-answer": "Selecteer één antwoord om door te gaan",
  "ld-pass-mark-note":
    "U heeft {passMark}% of hoger nodig om te slagen. Antwoorden kunnen na verzenden niet meer worden gewijzigd.",
  "ld-questionnaire-not-configured": "De vragenlijst is niet geconfigureerd.",
  "ld-unable-load-questionnaire": "Vragenlijst kan niet worden geladen.",
  "ld-no-visible-questions":
    "Er zijn momenteel geen vragen beschikbaar voor deze kennistoets.",
  "ld-unable-submit-answers":
    "Antwoorden kunnen niet worden verzonden. Probeer het opnieuw.",
  "ld-not-passed": "Niet geslaagd",
  "ld-completed": "Voltooid",
  "ld-fail-title": "Net niet gehaald — probeer het opnieuw",
  "ld-fail-description":
    "U scoorde {score} — de slagingsdrempel is {passMark}%. U heeft nog {remaining}.",
  "ld-attempts-remaining":
    "{count, plural, one {# poging} other {# pogingen}}",
  "ld-attempt-of": "Poging {current} van {total}",
  "ld-fail-alert":
    "Neem even de tijd om de training opnieuw te bekijken en doe daarna de toets opnieuw. Na uw laatste poging wordt de toets vergrendeld.",
  "ld-try-again": "Opnieuw proberen",
  "ld-review-guidance": "Training opnieuw bekijken",
  "ld-locked-title": "Deze training is nu vergrendeld",
  "ld-locked-description":
    "U scoorde {score} — de slagingsdrempel voor dit pakket is {passMark}%. Om compliance-redenen kunt u het hier niet opnieuw doen.",
  "ld-speak-to-manager": "Neem contact op met uw manager",
  "ld-locked-manager-copy":
    "Uw manager kan {courseTitle} opnieuw toewijzen, zodat u de training opnieuw kunt doorlopen en de toets opnieuw kunt doen.",
  "ld-close-window": "U kunt dit venster nu sluiten.",
  "ld-close-window-safe": "U kunt dit venster nu veilig sluiten.",
  "ld-success-title": "Gefeliciteerd!",
  "ld-success-description":
    "U heeft {courseTitle} succesvol afgerond. Dit is vastgelegd in uw trainingsprofiel — u hoeft niets meer te doen.",
  "ld-email-yourself": "Stuur uzelf een kopie",
  "ld-email-copy-description":
    "Stuur een bevestiging van afronding naar uw inbox voor uw administratie.",
  "ld-email-placeholder": "u@bedrijf.com",
  "ld-sent": "Verzonden",
  "ld-sending-email": "Verzenden…",
  "ld-unable-send-email": "E-mail kan niet worden verzonden. Probeer het opnieuw.",
  "ld-email-sent-success": "Bevestigingsmail is succesvol verzonden!",
  "ld-video-briefing": "Videobriefing",
  "ld-document": "Document",
  "ld-video-meta": "Video",
  "ld-video-meta-no-skip": "Video · niet vooruitspoelen",
  "ld-document-meta": "Document · PDF",
  "ld-document-meta-scroll": "Document · PDF · scroll tot het einde",
  "ld-video-instruction-full": "Bekijk volledig — u kunt niet vooruitspoelen",
  "ld-video-instruction": "Bekijk de briefing en ga daarna verder",
  "ld-document-instruction-scroll": "Scroll tot het einde om door te gaan",
  "ld-document-instruction": "Bekijk het document en ga daarna verder",
  "ld-questionnaire": "Vragenlijst",
  "ld-confirmation": "Bevestiging",
  "ld-question-count": "{count, plural, one {# vraag} other {# vragen}}",
  "ld-knowledge-check-subtitle": "Kennistoets",
  "ld-score": "Score",
  "ld-whats-involved-pass-mark":
    "Slagingsdrempel {passMark}% · wordt ontgrendeld na de training",
  "ld-document-type-pdf": "{documentType} · PDF",
};
